export default __webpack_public_path__ + "0cc237d5f02e14d3a916b611422541bf.woff";